import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useToast } from '../../components/Toast';
import { technicalFaq } from '../../data/support/technicalFaq';
import { SupportFaqList, SupportGuideLayout, SupportHelpFooter, openChannelTalk } from './SupportGuide';

const TechnicalPage = () => {
  const { showToast } = useToast();
  const handleChat = () => openChannelTalk(showToast);

  return (
    <>
      <Helmet>
        <title>왓퀴즈 기술 지원 | 로그인·브라우저 문제 해결</title>
        <meta name="description" content="로그인, 브라우저, 성능 문제를 해결하는 방법을 안내해요." />
        <meta name="keywords" content="왓퀴즈 기술지원, 교사 인증 오류, 브라우저 호환성, AI 플랫폼 성능, 로그인 오류" />
        <meta property="og:title" content="왓퀴즈 기술 지원 | 로그인·브라우저 문제 해결" />
        <meta property="og:description" content="로그인, 브라우저, 성능 문제를 해결하는 방법을 안내해요." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://whatquiz.co.kr/support/technical" />
      </Helmet>

      <SupportGuideLayout current="로그인·오류 해결">
        <section className="sg__hero">
          <h1>로그인·오류 해결</h1>
          <p>대부분 아래 방법으로 바로 풀려요. 안 되면 평일 09:00~18:00에 채팅으로 도와드려요</p>
          <button type="button" className="sg__cta" onClick={handleChat}>채팅으로 물어보기</button>
        </section>

        <section className="sg__card">
          <h2>자주 생기는 문제</h2>
          <SupportFaqList faqs={technicalFaq} />
        </section>

        <SupportHelpFooter text="그래도 안 되면" onChat={handleChat} />
      </SupportGuideLayout>
    </>
  );
};

export default TechnicalPage;
